import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BreakpointObserver } from '@angular/cdk/layout';
import { takeUntil } from 'rxjs/operators';
import { AddEntityDialogComponent } from './fieldinstance/addEntityDialog.component';
import { EventBusService } from './EventBusService';
import { ClearObservable } from '../shared/classes/clear-observable';
import { CachedlistcompService } from '@savvy/cached-view';
import { ContextIdDto, EntityDefinitionId, EntityInstanceId, IdNameTupleDto } from '@savvy/view-definition';

@Component({
  selector: 'app-ei-selector',
  templateUrl: 'eiSelector.component.html'
})

export class EiSelectorComponent extends ClearObservable implements OnInit {

  @Input() entityDefinitionId: EntityDefinitionId;
  @Input() contextIdDto: ContextIdDto;
  @Input() entityInstanceId: EntityInstanceId;
  @Input() entityDefinitionLabel: string;
  @Output() eiChanged = new EventEmitter();

  eventBus = new EventBusService();

  initialised = false;
  entityInstanceIdField: string;
  entityInstanceIdFieldValueTupleDtos: Array<IdNameTupleDto> = [];
  private timeout;
  constructor(
    private breakpointObserver: BreakpointObserver,
    public dialog: MatDialog,
    private cachedListCompositeApi: CachedlistcompService) {
    super();
  }

  ngOnInit() {
    if (this.entityInstanceId) {
      console.log('got entity instace ' + this.entityInstanceId);
      this.entityInstanceIdField = this.entityInstanceId.id;
      this.loadTypeaheadAndSet(this.entityInstanceIdField);
    } else {
      // console.log('no entity instance passed in');
      this.initialised = true;
    }
  }


  displayFn(id) {
    if (!id) {
      return '';
    }
    console.log('looking for id ' + id);
    console.log('entityInstanceIdFieldValueTupleDtos ' + this.entityInstanceIdFieldValueTupleDtos.length);
    const index = this.entityInstanceIdFieldValueTupleDtos.findIndex(state => state.id === id);
    if (index === -1) {
      console.log('id is ' + id + ' index is' + index + ' this should never happen as tuples should always be there first');
      return '';
    } else {
      return this.entityInstanceIdFieldValueTupleDtos[index].name;
    }
  }

  private loadTypeaheadAndSet(entityInstanceId: string) {
    console.log('loadTypeaheadAndSet:1 entityInstanceId', entityInstanceId);
    console.log('this.entityDefinitionId', this.entityDefinitionId);
    this.cachedListCompositeApi.loadSingleEiTypeahead(
      this.contextIdDto.contextId,
      this.contextIdDto.contextIdType,
      entityInstanceId).pipe(takeUntil(this.destroy$)).subscribe(response => {
        if (response.entityInstanceIdFieldValueTupleDto) {
          console.log('got response ');
          this.entityInstanceIdFieldValueTupleDtos = [];
          this.entityInstanceIdFieldValueTupleDtos[0] = response.entityInstanceIdFieldValueTupleDto;
          this.entityInstanceIdField = response.entityInstanceIdFieldValueTupleDto.id;
        } else {
          console.log('error, expecting an id on ', response.entityInstanceIdFieldValueTupleDto);
        }
        this.initialised = true;
      });
  }

  loadTypeahead(searchString: string) {
    if (searchString && searchString.length > 0) {
      this.cachedListCompositeApi.listForTypeahead(
        this.contextIdDto.contextId,
        this.contextIdDto.contextIdType,
        this.entityDefinitionId.id,
        searchString).pipe(takeUntil(this.destroy$)).subscribe(
          result => {
            console.log('got loadProductsResponse ', result);
            this.setResponse(result);
          }, err => {
            console.log('error while loadTypeahead', err);
          });
    }
  }

  setResponse(result) {
    this.entityInstanceIdFieldValueTupleDtos = result.entityInstanceIdFieldValueTupleDtos;
    if (result.entityInstanceIdFieldValueTupleDtos.length === 0) {
      // const idNameTupleDto = <IdNameTupleDto>{};
      // this.entityInstanceIdFieldValueTupleDtos.push(idNameTupleDto);
    }
  }


  onKey(event) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      //      this.form.controls[this.entityInstanceId].setErrors({'doesNotSelected': true});
      this.loadTypeahead(event.target.value);
    }, 500);
  }

  changedSelection(tupleId: string) {
    if (tupleId) {
      console.log('new one ' + tupleId);
      this.eiChanged.emit(tupleId);
    }
  }

  createNewLinkedEntity() {
    const dialogRef = this.dialog.open(AddEntityDialogComponent, {
      data: {
        contextIdDto: this.contextIdDto,
        entityDefinitionId: this.entityDefinitionId.id,
        entityDefinitionLabel: this.entityDefinitionLabel,
        eventBus: this.eventBus
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.entityInstanceId) {
        console.log('got a new instance to link to ' + result.entityInstanceId);
        this.eiChanged.emit(result.entityInstanceId);
        this.loadTypeaheadAndSet(result.entityInstanceId);
      }
    });
  }
}
